import { useState, useEffect } from "react";

export interface VisualViewportState {
  height: number;
  offsetTop: number;
}

export function useVisualViewport(): VisualViewportState | null {
  const [vp, setVp] = useState<VisualViewportState | null>(null);

  useEffect(() => {
    const vv = window.visualViewport;
    let rafId: number | null = null;

    if (vv) {
      const update = () => {
        if (rafId !== null) return;
        rafId = requestAnimationFrame(() => {
          rafId = null;
          setVp(prev => {
            if (prev && prev.height === vv.height && prev.offsetTop === vv.offsetTop) return prev;
            return { height: vv.height, offsetTop: vv.offsetTop };
          });
        });
      };
      update();
      vv.addEventListener("resize", update);
      vv.addEventListener("scroll", update);
      return () => {
        vv.removeEventListener("resize", update);
        vv.removeEventListener("scroll", update);
        if (rafId !== null) cancelAnimationFrame(rafId);
      };
    } else {
      const update = () => {
        if (rafId !== null) return;
        rafId = requestAnimationFrame(() => {
          rafId = null;
          setVp(prev => {
            if (prev && prev.height === window.innerHeight && prev.offsetTop === 0) return prev;
            return { height: window.innerHeight, offsetTop: 0 };
          });
        });
      };
      update();
      window.addEventListener("resize", update);
      return () => {
        window.removeEventListener("resize", update);
        if (rafId !== null) cancelAnimationFrame(rafId);
      };
    }
  }, []);

  return vp;
}

/** @deprecated use useVisualViewport() instead */
export function useVisualViewportHeight(): number | null {
  const vp = useVisualViewport();
  return vp?.height ?? null;
}
